// extracted by mini-css-extract-plugin
export default {"root":"SettlementsSettings_root__+32bZ"};